import { render, staticRenderFns } from "./SensorData.vue?vue&type=template&id=6389330d"
import script from "./SensorData.vue?vue&type=script&lang=js"
export * from "./SensorData.vue?vue&type=script&lang=js"
import style0 from "./SensorData.vue?vue&type=style&index=0&id=6389330d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports